// @ts-nocheck
import {Column} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {charge} from '../../core/_models'
import {CustonCell} from './CustonCell'
import {formatMonetaryToBr} from '../../../../../../utils/formatMonetaryToBr'
import {formatDateTime} from '../../../../../../utils/dayJs/format'

const chargeTypeLabels: Record<string, string> = {
  'digital-sign': 'Assinatura Digital',
  'billing-settlement': 'Taxa de Baixa de Parcela',
  'sms-send': 'Envio de SMS',
  'email-send': 'Envio de E-mail',
  'person-validation': 'Validação de Pessoa',
  'cep-validation': 'Validação de CEP',
  'phone-validation': 'Validação de Telefone',
}

const ChargesColumns: ReadonlyArray<Column<charge>> = [
  {
    Header: (props) => <CustomHeader tableProps={props} title='Id' className='min-w-125px' />,
    id: 'id',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Ocorrido em' className='min-w-125px' />
    ),
    id: 'occurredAt',
    Cell: ({...props}) => (
      <CustonCell value={formatDateTime(props.data[props.row.index].occurredAt)} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Tipo' className='min-w-125px' />,
    id: 'chargeType',
    Cell: ({...props}) => (
      <CustonCell
        value={chargeTypeLabels[props.data[props.row.index].chargeType] ?? props.data[props.row.index].chargeType}
      />
    ),
  },
  // {
  //   Header: (props) => <CustomHeader tableProps={props} title='Evento' className='min-w-50px' />,
  //   id: 'isReversal',
  //   Cell: ({...props}) => (
  //     <CustonCell value={props.data[props.row.index].isReversal ? 'Estorno' : 'Cobrança'} />
  //   ),
  // },
  // {
  //   Header: (props) => <CustomHeader tableProps={props} title='Origem' className='min-w-125px' />,
  //   id: 'chargeableSummary',
  //   Cell: ({...props}) => (
  //     <CustonCell value={props.data[props.row.index].chargeableSummary ?? '-'} />
  //   ),
  // },
  // {
  //   Header: (props) => (
  //     <CustomHeader tableProps={props} title='Forma de Pagamento' className='min-w-50px' />
  //   ),
  //   id: 'paymentOption',
  //   Cell: ({...props}) => (
  //     <CustonCell value={props.data[props.row.index].paymentOption?.name ?? '-'} />
  //   ),
  // },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Valor' className='min-w-50px' />,
    id: 'price',
    Cell: ({...props}) => (
      <CustonCell value={formatMonetaryToBr(props.data[props.row.index].price)} />
    ),
  },
]

export {ChargesColumns}